import { useState, type ReactElement } from 'react';
import { ORDNER_MAX, ordnerName, ordnerVorschlag } from '@schnitt/shared';

/**
 * Der Ordner eines Projekts: eine Auswahl, kein freies Textfeld.
 *
 * Sascha am 4. September: „das ist kein freies Textfeld“. Vorher tippte man
 * den Namen ein, und aus „Kunden“ und „kunden“ wurden zwei Ordner mit je der
 * Haelfte der Projekte darin.
 *
 * Jetzt stehen die vorhandenen als Knoepfe da, „Ohne Ordner“ daneben, und
 * einen neuen anzulegen ist eine eigene Handlung. Wer trotzdem einen tippt,
 * der einem vorhandenen aehnelt, bekommt ihn vorgeschlagen -- gefragt, nicht
 * entschieden: „2025“ neben „2026“ ist kein Vertipper, und wer es getrennt
 * will, tippt weiter.
 */
export function OrdnerWahl({
  wert,
  vorhandene,
  onWahl,
}: {
  wert: string;
  vorhandene: string[];
  onWahl: (ordner: string) => void;
}): ReactElement {
  const [neu, setNeu] = useState<string | null>(null);
  const vorschlag = neu !== null ? ordnerVorschlag(neu, vorhandene) : null;
  const sauber = ordnerName(neu ?? '');

  return (
    <div data-ordner-wahl>
      <div className="chips">
        <button
          className={`chip ${wert === '' ? 'active' : ''}`}
          data-ordner=""
          onClick={() => {
            setNeu(null);
            onWahl('');
          }}
        >
          Ohne Ordner
        </button>
        {vorhandene.map((f) => (
          <button
            key={f}
            className={`chip ${wert === f ? 'active' : ''}`}
            data-ordner={f}
            onClick={() => {
              setNeu(null);
              onWahl(f);
            }}
          >
            {f}
          </button>
        ))}
        {/* Der aktuelle Ordner steht nicht in der Liste, weil er nur an diesem
            einen Projekt haengt: dann gehoert er trotzdem angezeigt. */}
        {wert && !vorhandene.includes(wert) ? (
          <button className="chip active" data-ordner={wert}>
            {wert}
          </button>
        ) : null}
        {neu === null ? (
          <button className="chip" data-ordner-neu onClick={() => setNeu('')}>
            + Neuer Ordner
          </button>
        ) : null}
      </div>

      {neu !== null ? (
        <div className="stack" style={{ marginTop: 10 }}>
          <input
            value={neu}
            autoFocus
            maxLength={ORDNER_MAX}
            placeholder="Name des Ordners"
            data-ordner-name
            onChange={(e) => setNeu(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && sauber) {
                onWahl(sauber);
                setNeu(null);
              }
              if (e.key === 'Escape') setNeu(null);
            }}
          />
          {vorschlag ? (
            <button
              className="row"
              data-ordner-vorschlag
              onClick={() => {
                onWahl(vorschlag);
                setNeu(null);
              }}
            >
              Meinst du „{vorschlag}“?
            </button>
          ) : null}
          <div className="spread">
            <button
              className="primary"
              disabled={!sauber}
              data-ordner-anlegen
              onClick={() => {
                onWahl(sauber);
                setNeu(null);
              }}
            >
              Anlegen
            </button>
            <button className="ghost" onClick={() => setNeu(null)}>
              Abbrechen
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
